import { useCallback, type ReactNode } from 'react';
import type { ChatController } from 'flare-chat-core/controller';
import { useChatState } from 'flare-chat-core/react';

/** Initialization status is read from Core; no paint or URL check can fabricate readiness. */
export const ControllerBoundary = ({ controller, children }: { controller: ChatController; children?: ReactNode }) => {
  const { lifecycle } = useChatState();
  const retry = useCallback(() => { void controller.initialize(); }, [controller]);
  if (lifecycle.status === 'failed') return <div role="alert">
    {lifecycle.error?.message}<button onClick={retry}>重试</button>
  </div>;
  if (lifecycle.status !== 'ready') return <div role="status" aria-busy="true" />;
  return <>{children}</>;
};
